import React, { useState } from "react";
import { Button, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import LanguageButton from "../language/LanguageButton";
import "./LanguageMenu.css";
import { useTranslation } from "react-i18next";

const LanguageMenu = (props) => {
  const fleetId = props.fleetId || null;
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="language-menu-container">
      <Dropdown
        open={open}
        onOpenChange={setOpen}
        trigger={["click"]}
        dropdownRender={() => (
          <div className="language-menu-list">
            <LanguageButton fleetId={fleetId} />
          </div>
        )}
      >
        <Button className="language-menu-button">
          {t("login.languageMenu")} <DownOutlined className={`language-chevron ${open ? "rotate" : ""}`} />
        </Button>
      </Dropdown>
    </div>
  );
};

export default LanguageMenu;
